/**
 * BinaryBirthday — Auto-fill binary code from URL parameter
 * Reads ?binary=... from the URL and pre-fills the "Your Binary Code" field
 */
(function () {
  function autofill() {
    const params = new URLSearchParams(window.location.search);
    const binary = params.get('binary');
    if (!binary) return;

    // Find the binary code textarea by its name attribute
    const textarea = document.querySelector('textarea[name="properties[Your Binary Code]"]');
    if (!textarea) return;

    // Decode and set the value
    const decoded = decodeURIComponent(binary);
    textarea.value = decoded;

    // Trigger the bit counter update
    textarea.dispatchEvent(new Event('input', { bubbles: true }));

    // Scroll to the field and highlight it briefly
    textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
    textarea.style.transition = 'border-color 0.3s';
    textarea.style.borderColor = '#4ade80';
    textarea.focus();

    // Clean the URL so the code doesn't persist on page reload
    const cleanUrl = window.location.pathname +
      (params.toString().replace(/binary=[^&]*&?/, '').replace(/&$/, '') ? '?' + params.toString().replace(/binary=[^&]*&?/, '').replace(/&$/, '') : '');
    window.history.replaceState({}, '', cleanUrl);
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autofill);
  } else {
    autofill();
  }
})();
